import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

export const initVacanciesTeamSlider = () => {
	const container = document.querySelector('.vacancies-team-slider');
	if (!container) return;

	new Swiper(container, {
		modules: [Autoplay, Pagination],
		slidesPerView: 1,
		allowTouchMove: true,
		grabCursor: true,
		loop: true,
		autoplay: {
			delay: 4000,
		},
		pagination: {
			el: container.querySelector('.swiper-pagination'),
			clickable: true,
		},
	});
};
